import React from 'react'

// components
import ActionButton from '../../../../../components/buttons/ActionButton/ActionButton.component';

// mui
import { Stack, Grid } from '@mui/material';

const EquipmentRequestDetailProcessing = ({ data, loading, error, onProcessClicked, onAddItemsClicked }) => {

    return (<React.Fragment>
        {
            !loading 
            && data 
            && data.equipmentRequest.status !== 'H' 
            && 
            <React.Fragment>
                <ActionButton label="Add Items" color="secondary" onClick={onAddItemsClicked}/>
                <ActionButton label="Process Request" color="secondary" onClick={onProcessClicked}/>
            </React.Fragment>
        }
    </React.Fragment>)
}

export default EquipmentRequestDetailProcessing;